import { Link } from "react-router-dom";
import { NAV_LINKS, SITE } from "@/config/site";

export default function Footer() {
  return (
    <footer className="grain relative bg-ink text-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20 sm:py-24">
        <div className="grid gap-14 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="inline-flex items-center gap-4">
              <span className="inline-flex rounded-2xl bg-white p-2.5">
                <img
                  src={SITE.images.logo}
                  alt="Logo Nutrimove Lab"
                  className="h-14 w-14 object-contain"
                  width={56}
                  height={56}
                  loading="lazy"
                />
              </span>
              <span>
                <span className="block font-display text-2xl tracking-tight">{SITE.brand}</span>
                <span className="block text-xs uppercase tracking-[0.24em] text-white/50 mt-1">
                  {SITE.city}
                </span>
              </span>
            </div>
            <p className="mt-8 max-w-sm text-sm leading-relaxed text-white/60">
              {SITE.professional.name}
              <br />
              Biologo Nutrizionista
              <br />
              Dott. in Scienze Motorie
            </p>
          </div>

          <div>
            <h2 className="eyebrow text-white/40">Esplora</h2>
            <ul className="mt-6 space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(" ", "-")}`}
                    className="text-sm text-white/70 transition-colors duration-200 hover:text-leaf"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="eyebrow text-white/40">Contatti</h2>
            <ul className="mt-6 space-y-3 text-sm text-white/70">
              <li>
                Email —{" "}
                <a href={SITE.contacts.emailHref} data-testid="footer-email" className="transition-colors duration-200 hover:text-leaf">
                  {SITE.contacts.email}
                </a>
              </li>
              <li>
                Telefono —{" "}
                <a href={SITE.contacts.phoneHref} data-testid="footer-phone" className="transition-colors duration-200 hover:text-leaf">
                  {SITE.contacts.phone}
                </a>
              </li>
              <li>
                WhatsApp —{" "}
                <a href={SITE.contacts.whatsappHref} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="transition-colors duration-200 hover:text-leaf">
                  {SITE.contacts.whatsapp}
                </a>
              </li>
              <li>
                Instagram —{" "}
                <a href={SITE.contacts.instagramHref} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="transition-colors duration-200 hover:text-leaf">
                  {SITE.contacts.instagram}
                </a>
              </li>
              <li>Sedi — Bologna · Casalecchio di Reno</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} {SITE.brand} — brand di {SITE.legal.owner}, {SITE.legal.form} · P.IVA {SITE.legal.vat}. Tutti i diritti riservati.
          </p>
          <div className="flex gap-6 text-xs">
            <Link
              to="/privacy-policy"
              data-testid="footer-privacy-link"
              className="text-white/50 transition-colors duration-200 hover:text-white"
            >
              Privacy Policy
            </Link>
            <Link
              to="/cookie-policy"
              data-testid="footer-cookie-link"
              className="text-white/50 transition-colors duration-200 hover:text-white"
            >
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
